import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button ,Form,Spinner,} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { VendorService } from "../../Common/Services/VendorService";
import {Utils}  from "../../Common/Utilis";
import _ from "lodash";
import paginationFactory from 'react-bootstrap-table2-paginator';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import createDOMPurify from "dompurify";
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import moment from "moment";
import { JobTrackerServices } from "../../Common/Services/JobTrackerServices";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import JobCreations  from '../JobCreations';
import NCRSlideout  from './NCRSlideout';

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";

import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";

const { SearchBar } = Search;


//import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import 'react-tabs/style/react-tabs.css';


const DOMPurify = createDOMPurify(window);

class NCR extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      processid:[],
      footershow: false,
      selectedRows: [],
      isOrderDate:true,
      isvendorname:true,
      isvendorOrderType:true,
      isvendorPoNumber:true,
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],      
      isNCRDate:true,      
      isPartNo:true,
      isPartName:true,
      isCustomerName:true,
      isExplanation:true,
      isJobNo:true,
      selectedcolumn:"All",
      taboption:"first",
      IsAdded:false,
      selectOptions :  [ {
        id: 'All',name: 'All'},
      {  id: 'Part No',name: 'Part No'},
        {id: 'Customer Name',name:  'Customer Name'},
        {id: 'Part Name',name:  'Part Name'},
        { id: 'Job #',name:  'Job No.'},       
        { id: 'Explanation',name:  'Explanation'},       
     ],
    };
    

 
  }
 

  componentDidMount() { 
   this.getJobItems();
  }

  componentDidUpdate(prevProps) {
        if (prevProps.locationId != this.props.locationId && !this.state.showSlideout) {
          this.getJobItems();
        }
      }
 

  getJobItems()
  {
    let requestlist = { ...this.state.requestlist };
    requestlist.checkForReworkCount = 1;
    JobTrackerServices.GetNCRJobData(requestlist)
    .then(async (result: any[] | null) => {
      if (result != null) {
        this.setState({ searcResult: result}, () => {    
        });
      }
      resolve();
    })
    .catch((err: any) => {
      toast.error(`Server Error, ${err}`);
      reject();
    });
  }

  shownewslideout   = () => {
    this.setState({ showSlideout: true ,id:0,jobid:0,jobno:0,isSpinner:false,});
  };


  showslideout = () => {
    this.setState({ showSlideout: true , isSpinner:false, });
  };

  closeSlideOut = () => {
    this.setState({ showJobSlideout: false, isSpinner:false,showSlideout:false,IsAdded:true,selectRows:[] });
    this.getJobItems();
};

closeSlideOut1 = () => {
  this.setState({ showJobSlideout: false, isSpinner:false,showSlideout:false,processid:[],IsAdded:false,selectedRows:[]});
  this.getJobItems();
};

 rowEvents = {

  onClick: (e: any, row: any, rowIndex: any) => {
   
    if (e.target.tagName !== 'BUTTON') 
    {     
     
     this.setState({ showSlideout: true ,id:row.id,jobid:row.jobId,jobno:row.jobNo,footershow:false, isSpinner:false,}); 
    } 
  
  },
};


rowEvents1 = {
  onClick: (e, row, rowIndex) => {
    const isSelected = this.state.searcResult.some(
      x => x.uniqueId === row.uniqueId && x.selected === true
    );

    this.handleOnSelect(row, !isSelected);
  }
};


createNCR = () => {
  const { selectedRows, searcResult } = this.state;
  if (selectedRows.length === 0) {
    console.warn("No row selected.");
    return;
  }

  const selectedJobId = selectedRows[0];

  const match = searcResult.find(
    (item) => item.uniqueId == selectedJobId
  );

  if (match) {
    this.setState({
      showSlideout: true,
      id: match.id,
      jobid: match.jobId,
      jobno: match.jobNo,
      isSpinner: false,
      footershow: false,
    });
  } else {
    console.warn("No matching record found for jobId:", selectedJobId);
  }
};



handleSelectedItem1 = (control: any, id: any) => {
  let searcResult1 = Object.assign(
    [],
    JSON.parse(JSON.stringify(this.state.searcResult))
  );

  let isPartNo = id == "Part No" ? true : false;
  let isCustomerName = id == "Customer Name" ? true : false;
  let isPartName = id == "Part Name" ? true : false;
  let isJobNo = id == "Job #" ? true : false;
  let isNCRDate = id == "NCR Date" ? true : false;
  let isExplanation = id == "Explanation" ? true : false;

  if (id == "All") {  
    isNCRDate=true;      
    isPartNo=true;
    isPartName=true;
    isCustomerName=true;
    isExplanation=true;
    isJobNo=true;
  }


  this.setState({
    searcResult: [], selectedcolumn: id, isNCRDate: isNCRDate, isPartNo: isPartNo,
    isPartName: isPartName, isjobNo: isJobNo,isCustomerName:isCustomerName,isExplanation:isExplanation
  },
    () => {
      this.setState({ searcResult: searcResult1 });
    }

  );

};

handleSelectedItem = (rowIndex: any,control: any,rowid:any, value: any) => {
  let searcResultReceiving = Object.assign(
    [],
    JSON.parse(JSON.stringify(this.state.searcResultReceiving))
  );

 
 
    let selectedRow = searcResultReceiving.filter((x)=> x.rowId == rowid);
    if(selectedRow.length > 0)
       selectedRow[0].received = value;
if(value=="Partial")
  {
    selectedRow[0].qtyReceived = 0;
  }
  this.setState({
    searcResultReceiving: searcResultReceiving,isStateChanged: true
  },
    () => {
      this.setState({ searcResultReceiving: searcResultReceiving});
    }
  );
};





 
reopenSlideOutWithReworkJob = () => {
  this.setState({ showJobSlideout: false}, () => {
   
   let rNo = Utils.extractIncrementedRNumber(this.state.jobNo);
   this.setState({ showJobSlideout: true,footershow:false,showCustomerSlideout: false, jobid: 0,rNo:rNo});
  });
  

};

showJobSlideOut = (row,type) => {  

  if(type === 'job')
  {
   
    let jobNo =  Utils.removeRNumber(row.jobNo);
    let itemNo = Utils.extractNumberAfterHyphen(jobNo);
    let rNo = Utils.extractRNumber(row.jobNo);
    this.setState({ showJobSlideout: true,footershow:false,showCustomerSlideout: false, orderid:row.orderDetailId ,jobid: row.jobId,qtyOrdered:row.qty,partname:row.partName,partNo:row.partNo,selectedCustomer:row.customerName,productid:row.partId,CustomerPoNumber:row.customerPoNumber,itemNo:itemNo,jobNo:row.jobNo,rNo:rNo});
  }
   
};

printOrder = (ncrid,jobId) => {
  let request: any = {};
  request.ncrId = ncrid;
  request.jobId = jobId;

  this.setState({ isSpinner: true });

  JobTrackerServices.DownloadNCRFile(request)
    .then(async (result: any | null) => {
      //this.HidecloseSlideOut();
      this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
      resolve();
    })
    .catch((error) => {
      reject();
      this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
    });
};
// handleSelect = (key) => {
//   console.log(key,';;',typeof key);
//   if(key === '1') {
//       console.log('ll', key);
//   } else if(key === '2') {
//     console.log('ll', key);
//   } else if(key === '3') {
//     console.log('ll', key);
//   }
// };

handleSelect = (key: string | null) => {
  this.setState({ taboption: key || "first" });
};

handleOnSelect = (row: any, isSelect: boolean): void => {
  let { searcResult } = this.state;

  searcResult = searcResult.map(item => ({ ...item }));

  let selectedRows: string[] = [];
  let processid: number[] = [];

  const currentJobId = row.jobId;

  const selectedItem = searcResult.find(x => x.selected);
  const activeJobId = selectedItem ? selectedItem.jobId : null;

  if (isSelect && activeJobId !== null && activeJobId !== currentJobId) {
    searcResult.forEach(x => (x.selected = false));
  }

  searcResult.forEach(item => {
    if (
      item.uniqueId === row.uniqueId &&
      (!item.ncrNo || item.ncrNo.length === 0)
    ) {
      item.selected = isSelect;
    }
  });

  searcResult.forEach(item => {
    if (item.selected) {
      selectedRows.push(item.uniqueId);
      processid.push(item.processId);
    }
  });

  selectedRows = Array.from(new Set<string>(selectedRows));
  processid = Array.from(new Set<number>(processid));

  this.setState({
    searcResult,
    selectedRows,
    processid,
    footershow: selectedRows.length > 0
  });
};




 handleOnSelectold = (row, isSelect) => {
    let { selectedRows} = this.state;

    let searcResult = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );

      searcResult.forEach(item => {
      item.selected = false;
    });

   let listItem = searcResult.filter(
  (x) => x.uniqueId === row.uniqueId && (x.ncrNo == null || x.ncrNo.length === 0)
);


      if (isSelect) {
        selectedRows = [row.uniqueId];

      } else {
        selectedRows = [];
      }
    
  
      listItem[0].selected = isSelect;
      let selectedCount = searcResult.filter(x=>x.selected == true).length;
  
    this.setState({ searcResult: searcResult, footershow: selectedCount > 0 ? true :false, selectedRows: selectedRows,processid:row.processId });


  };

 discard = () => {
    
    let searcResult = this.state.searcResult;
    searcResult.forEach(element => {
     element.selected = false;      
    });

    this.setState({ searcResult: searcResult, footershow: false, selectedRows: []});
   
  };

   render() { 
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );
    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: this.state.searcResult.length
      }] // A numeric array is also available. the purpose of above example is custom the text
    };

    const columns = [
  
      
      {
        dataField: 'ncrNo',
        text: 'NCR No',
        sort: true,
        headerStyle: { width: '100px' },
        searchable:this.state.isNCRNo,
        hidden:false,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.ncrNo}
             </EllipsisWithTooltip>
          );
        },
      }, 
      
      {
        dataField: 'ncrDate',
        text: 'NCR Date',
        sort: true,
        headerStyle: { width: '100px' },
        searchable:this.state.isNCRDate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
              <EllipsisWithTooltip placement="bottom">
                  {row.ncrDate != null && row.ncrDate.length > 0 ? moment(row.ncrDate).format("MM/DD/YYYY"):''}
              </EllipsisWithTooltip>
          );
      },
      },
      {
        dataField: 'typeOfNCR',
        text: 'NCR Type',
        sort: true,
        headerStyle: { width: '100px' },
        //searchable:this.state.isExplanation,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.typeOfNCR}
             </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'jobNo',
        text: 'Job No.',
        sort: true,
        headerStyle: { width: '100px' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             <Button className="btn-link" onClick={() => this.showJobSlideOut(row,'job')}>
             {row.jobNo}
             </Button>
             </EllipsisWithTooltip>
          );
        },
        searchable:this.state.isJobNo,
      },
      {
        dataField: 'partNo',
        text: 'Part No',
        sort: true,
        headerStyle: { width: '150px' },
        searchable:this.state.isPartNo,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.partNo}
             </EllipsisWithTooltip>
          );
        },
      }, 
      {
        dataField: 'partName',
        text: 'Part Description',
        sort: true,
        classes:"text-truncate",
          headerStyle: { width: "10%" },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
             
              <div className="d-flex align-items-center txt-bold">
              <div style={{width: '150px'}}>
             <EllipsisWithTooltip placement="bottom">
               {row.partName}
             </EllipsisWithTooltip>
           </div>
           </div>
            );
        
        },
      },     
      {
        dataField: 'customerName',
        text: 'Customer Name',
        sort: true,
        hidden:true,
        headerStyle: { width: '150px' },
        searchable:this.state.isCustomerName,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.customerName}
             </EllipsisWithTooltip>
          );
        },
      },
    
      
      {
        dataField: 'ncrStatus',
        text: 'Status',
        sort: true,
        headerStyle: { width: '100px' },
        //searchable:this.state.isExplanation,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             
             <span className={ row.ncrStatus=="Completed" ?  "badge badge-pill badge-primary color-green": "badge badge-pill badge-primary color-red"}> {row.ncrStatus}</span>
             </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'TrackerStatus',
        text: 'Recomended Action',
        sort: true,
        headerStyle: { width: '100px' },
        //searchable:this.state.isExplanation,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">

  {(row.trackerStatus=="" || row.trackerStatus==null || row.trackerStatus==undefined && <span></span> )}
  {(row.trackerStatus!="" && row.trackerStatus!=null && row.trackerStatus!=undefined &&    <span className={ row.trackerStatus=="Use it as is" ?  "badge badge-pill badge-primary color-green":  "badge badge-pill badge-primary color-red"}> {row.trackerStatus}</span>
           
          )}
            
             </EllipsisWithTooltip>
          );
        },
      },
      // {
      //   dataField: '',
      //   text: 'Print',
      //   sort: true,
      //   hidden: false,
      //   headerStyle: { width: '150px' },
      //  // searchable:this.state.isExplanation,
      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     return (
      //       <Button variant="primary"   className="btn btn-primary px-4" onClick={()=>this.printOrder(row.id,row.jobId)}> Print</Button>
      //     );
      //   },
      // },

      // {
      //   dataField: '',
      //   text: 'Action',


      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     return (
      //       <div className="btn-group">
      //         <Dropdown
      //           onClick={(e) => { e.stopPropagation(); }}
      //           className="more-action"
      //           >
      //           <Dropdown.Toggle
      //             className="btn-outline-primary btn btn-primary-white more"
      //             id={"dropdown-more" + rowIndex}

      //           >
      //             <svg
      //               width="20"
      //               height="20"
      //               viewBox="0 0 20 20"
      //               fill="none"
      //               xmlns="http://www.w3.org/2000/svg"
      //             >
      //               <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
      //               <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
      //               <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
      //             </svg>
      //           </Dropdown.Toggle>
      //           <Dropdown.Menu>
      //           <Dropdown.Item eventKey={"print"} onClick={()=>this.printOrder(row.id,row.jobId)}>Print </Dropdown.Item>
                  
                  
      //           </Dropdown.Menu>
      //         </Dropdown>
      //       </div>
      //     );
      //   },
      // },


    ];

    const columnsReported = [
     
      // {
      //   dataField: 'ncrDate',
      //   text: 'NCR Date',
      //   sort: true,
      //   headerStyle: { width: '100px' },
      //   searchable:this.state.isNCRDate,
      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     return (
      //         <EllipsisWithTooltip placement="bottom">
      //             {row.ncrDate != null && row.ncrDate.length > 0 ? moment(row.ncrDate).format("MM/DD/YYYY"):''}
      //         </EllipsisWithTooltip>
      //     );
      // },
      //},
      {
        dataField: 'jobNo',
        text: 'Job No.',
        sort: true,
        headerStyle: { width: '20%' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             <Button className="btn-link" onClick={() => this.showJobSlideOut(row,'job')}>
             {row.jobNo}
             </Button>
             </EllipsisWithTooltip>
          );
        },
        searchable:this.state.isJobNo,
      },
      {
        dataField: 'partNo',
        text: 'Part No',
        sort: true,
        headerStyle: { width: '20%' },
        searchable:this.state.isPartNo,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.partNo}
             </EllipsisWithTooltip>
          );
        },
      }, 
      {
        dataField: 'partName',
        text: 'Part Description',
        sort: true,
        headerStyle: { width: '30%'},
        classes:"text-truncate",
        searchable:this.state.isPartName,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
               <div style={{width: '150px'}}>
             {row.partName}
             </div>
             </EllipsisWithTooltip>
          );
        },
      },     
      {
        dataField: 'customerName',
        text: 'Customer Name',
        sort: true,
        headerStyle: { width: '20%' },
        searchable:this.state.isCustomerName,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.customerName}
             </EllipsisWithTooltip>
          );
        },
      },
    
      {
        dataField: 'isFixed',
        text: 'Type',
        sort: true,
        headerStyle: { width: '10%' },
        //searchable:this.state.isExplanation,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.isFixed ? "Process":"Material"}
             </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'stepNo',
        text: 'Step No',
        sort: false,
        headerStyle: { width: '20%' },
        searchable:false,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
             <EllipsisWithTooltip placement="bottom">
             {row.stepNo}
             </EllipsisWithTooltip>
          );
        },
      }, 
      // {
      //   dataField: 'TrackerStatus',
      //   text: 'Recomended Action',
      //   sort: true,
      //   headerStyle: { width: '100px' },
      //   //searchable:this.state.isExplanation,
      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     return (
      //        <EllipsisWithTooltip placement="bottom">
      //        {row.trackerStatus}
      //        </EllipsisWithTooltip>
      //     );
      //   },
      // },
      // {
      //   dataField: 'explanation',
      //   text: 'Explanation',
      //   sort: true,
      //   headerStyle: { width: '150px' },
      //   searchable:this.state.isExplanation,
      //   formatter: (cell: any, row: any, rowIndex: any) => {
      //     return (
      //        <EllipsisWithTooltip placement="bottom">
      //        {row.explanation}
      //        </EllipsisWithTooltip>
      //     );
      //   },
      // },
    ];

  

 

    const {
      
      showSlideout,
  } = this.state;

 
  

 

 
  




    return (
      <>
        <React.Fragment>



          <Container fluid className="body-sec">
            <div className="page-heading underline d-flex  ">

              Non-Compliance Report
              <div className="action-group d-flex flex-row ml-auto">
              {this.state.taboption == "first" && <Button onClick={this.shownewslideout}>Add NCR</Button>}

              </div>
            </div>

            <Tab.Container transition={false} activeKey={this.state.taboption}  onSelect={this.handleSelect}>

              <section className="pb-3">
                <Nav className="nav nav-underline border-bottom">
                    <Nav.Item className="nav-item">
                    <Nav.Link eventKey="first">All Reports
                    <span className="badge badge-light">   {this.state.searcResult.filter((x)=>x.ncrNo != null && x.ncrNo.length > 0).length}</span>

                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="second">Flagged <span className="badge badge-light">{this.state.searcResult.filter((x)=>(x.ncrNo == null || x.ncrNo.length == 0)).length}</span>


                    </Nav.Link>
                  </Nav.Item>
                

                </Nav>
              </section>

              <Tab.Content>
                  <Tab.Pane eventKey="first">

                  <ToolkitProvider
                    keyField="uniqueId"

                    data={ this.state.searcResult.filter((x)=>x.ncrNo !== null && x.ncrNo.length > 0) }
                    columns={ columns }
                    search
                  >
                    {
                      props => (


                        <div >
                          <section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>

                            <div
                            //className="input-group w-auto"
                            className='col-12 col-md-2'
                            >
                                <SingleDropdownListWithoutSearch

                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}

                                />
                            </div>

                          </section>
                          <section className="pb-3">
                            <div className="table-responsive divbottom"  >
                              <div className="ml-auto transactions-list payroll-tbl">
                              <BootstrapTable id ="tblGenerated"
          { ...props.baseProps }
          keyField="rowId"
          rowEvents={this.rowEvents}
        pagination={ paginationFactory(options) }
        defaultSorted={[
          {
            dataField: 'ncrDate',
            order: 'desc' 
          }
        ]}
        />
                              </div>
                            </div>
                          </section>
                        </div>

                      )
                    }
                  </ToolkitProvider>


                </Tab.Pane>

                <Tab.Pane eventKey="second">

                  <ToolkitProvider
                    keyField="uniqueId"
                    data={ this.state.searcResult.filter((x)=>(x.ncrNo == null || x.ncrNo.length == 0)) }
                    columns={ columnsReported }
                   
                     
                    search
                  >
                    {
                      props => (


                        <div >
                          <section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                            </div>

                            <div
                            //className="input-group w-auto"
                            className='col-12 col-md-2'
                            >
                                <SingleDropdownListWithoutSearch

                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}

                                />
                            </div>

                          </section>
                          <section className="pb-3">
                            <div className="table-responsive divbottom"  >
                              <div className="ml-auto transactions-list payroll-tbl">
                                <BootstrapTable
                                  {...props.baseProps}
                                  keyField="uniqueId"
                                  rowEvents={this.rowEvents1}
                                  pagination={paginationFactory(options)}
                                  selectRow={{
                                          mode: 'checkbox', clickToSelect: false, hideSelectAll: true,
                                          selected: this.state.searcResult.filter((x) => x.selected === true).map(r => r.uniqueId),
                                          onSelect: this.handleOnSelect,
                                          hideSelectColumn: false
                                        }}
                                />
                                {(this.state.footershow && this.state.selectedRows.length > 0 &&
                                <div className="TabFooter-Pay"
                                 style={{ minWidth: "83%", width: "992px", maxWidth: "100%" }}
                                >
                                <div className="bulkSelectFooter">                              
                                <div className="action-group d-flex flex-row mr-auto">
                                <Button type="button"
                                onClick={(x) => this.createNCR()}
                                >Create NCR</Button>
                                 <Button type="button"
                                                                   className='space btn btn-primary btn-discard'
                                                                   onClick={(x) => this.discard()}
                                                                  >Discard</Button>
                                </div>
                                </div>
                                </div>)}
                              </div>
                            </div>
                          </section>
                        </div>

                      )
                    }
                  </ToolkitProvider>


                </Tab.Pane>
              

              </Tab.Content>

            </Tab.Container>




            {(this.state.isSpinner || this.state.isSaveSpinner) && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}

{this.state.showSlideout && (

<NCRSlideout
  closeSlideOut={this.closeSlideOut1}
  jobid={this.state.jobid}
  id={this.state.id}
  jobno={this.state.jobno}
  processid={this.state.processid}
>
</NCRSlideout>
)}

{this.state.showJobSlideout && (

<JobCreations
  closeSlideOut={this.closeSlideOut}
  reopenSlideOutWithReworkJob = {this.reopenSlideOutWithReworkJob}
  jobid={this.state.jobid}
  orderid={this.state.orderid}
  CustomerPoNumber={this.state.CustomerPoNumber}
  poNumber={this.state.poNumber}
  productid={this.state.productid}
  partname={this.state.partname}
  partNo={this.state.partNo}
  qtyOrdered={this.state.qtyOrdered}

  itemNo={this.state.itemNo}
  selectedCustomer={this.state.selectedCustomer}
  orderdate={this.state.orderdate}
  dueDate={this.state.dueDate}
  jobDesc={this.state.jobDesc}
  id={this.state.orderid}
  rNo={this.state.rNo}

>
</JobCreations>
)}

          </Container>



        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions ,
  locationId: state.LocationReducer.locationId
});

export default connect(mapStateToProps)(NCR);